import { useAnimalStore } from '../Stores/animalStore'
import { currencyFormatter } from '../utils/currencyFormatter'

export const useIssueCost = () => {
  const { animalsList } = useAnimalStore()

  const getIssueCostValue = () => {
    const animal = animalsList?.[0]
    const packSelected = animal?.pack
    const installmentSelected = animal?.pack?.installment
    const issueCost = (packSelected?.premiums || [])?.find(
      (premium) => premium.installment === installmentSelected,
    )?.issueCost

    return currencyFormatter(issueCost || 0)
  }
  return {
    getIssueCostValue,
  }
}
